function cloneArrayWithSortedFields<T>(source: T[]): T[] {
    const result = [];

    for (let index = 0; index < source.length; index++) {
        result[index] = cloneWithSortedFields(source[index]);
    }

    return result;
}

/**
 * Clone function that's a bit slower than fast-clone but sorts
 * object properties by the property name. Useful for debugging when
 * comparing two stringified objects
 *
 * @param source - The object to clone
 * @returns The cloned and key-sorted value
 */
export function cloneWithSortedFields<T>(source: T): T {
    if (!source || typeof source !== 'object') {
        return source;
    }

    if (source instanceof Date) {
        const date = new Date();
        date.setTime(source.getTime());
        return date as any; // <-- have to use any...you know nothing TS compiler
    }

    if (source instanceof Array) {
        return cloneArrayWithSortedFields(source) as any;
    }

    const result: any = {};

    for (const key of Object.getOwnPropertyNames(source).sort()) {
        result[key] = cloneWithSortedFields((source as any)[key]);
    }

    return result as T;
}
